import classes from './bejzbol.module.css'
import { useState, useEffect } from 'react'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'

const AmerickiFudbal = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState(false)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      stats: ['', '', '', '', '', ''],
    },
    results: {
      oddsPercentages: ['', ''],
      goals: ['', '', '', ''],
      score: ['', ''],
      betko: [''],
      teamStrengths: ['', '', '', '', '', '', '', ''],
    },
  })
  //all inputs filled
  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        stats: ['', '', '', '', '', ''],
      },
      results: {
        oddsPercentages: ['', ''],
        goals: ['', '', '', ''],
        score: ['', ''],
        betko: [''],
        teamStrengths: ['', '', '', '', '', '', '', ''],
      },
    })
    setApiError(false)
    setShowInputArea(true)
  }

  const buildBody = () => {
    const odds = data?.values?.odds || ['', '']
    const setsBoth = data?.values?.stats || ['', '', '', '', '', '']

    const [odd1Str, odd2Str] = odds
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      setsBoth

    return {
      oddsHome: parseFloat(odd1Str) || 0,
      oddsAway: parseFloat(odd2Str) || 0,
      homeGoalsScored: parseInt(wins1Str, 10) || 0,
      homeGoalsConceded: parseInt(losses1Str, 10) || 0,
      homeMatchesPlayed: parseInt(played1Str, 10) || 0,
      awayGoalsScored: parseInt(wins2Str, 10) || 0,
      awayGoalsConceded: parseInt(losses2Str, 10) || 0,
      awayMatchesPlayed: parseInt(played2Str, 10) || 0,
    }
  }

  const calculateAll = async () => {
    setLoading(true)
    setApiError(false)
    try {
      const res = await runCalculator(
        'predictions',
        'american-football',
        buildBody()
      )

      setData((prev) => ({
        ...prev,
        results: {
          oddsPercentages: [res.side1WinPct, res.side2WinPct],
          goals: [
            Number(res.pointsMin).toFixed(2),
            Number(res.pointsAvg).toFixed(2),
            Number(res.pointsMax).toFixed(2),
          ],
          betko: [Number(res.suggestion).toFixed(2)],
          score: [res.correctScoreOption1, res.correctScoreOption2],
          teamStrengths: [
            Number(res.homeGoalsScoredAvg).toFixed(2),
            Number(res.homeGoalsConcededAvg).toFixed(2),
            Number(res.awayGoalsScoredAvg).toFixed(2),
            Number(res.awayGoalsConcededAvg).toFixed(2),
            Number(res.homeConcededAwayScoredAvg).toFixed(2),
            Number(res.homeScoredAwayConcededAvg).toFixed(2),
            Number(res.homeAwayScoredAvg).toFixed(2),
            Number(res.homeAwayConcededAvg).toFixed(2),
          ],
        },
      }))
      return true
    } catch (err) {
      setApiError(true)
      return false
    } finally {
      setLoading(false)
    }
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = async () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    const ok = await calculateAll()
    if (ok) {
      setShowInputArea(false)
    }
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Americki fudbal`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled || loading}>
            {loading
              ? 'Obračun u toku...'
              : showInputArea
                ? 'Prikaži rezultate'
                : 'Unesi obračunske podatke'}
          </button>
        </div>
        {apiError && (
          <div className={classesK.sectionTitle}>
            Greška pri obračunu, pokušajte ponovo.
          </div>
        )}
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod utakmice
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI 2']}
                step={['0.1', '0.1']}
                min={['0.1', '0.1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />

              <div className={classesK.sectionTitle}>
                Upiši br.golova/br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'stats'}
                labelPrefix={[
                  'DOM +  (dom. dao golova)',
                  'DOM - (dom. primio golova)',
                  'DOM BR. (dom. odigrao utakmica)',
                  'GOST +  (gost dao golova)',
                  'GOST-  (gost primio golova)',
                  'GOST BR. (gost odigrao utakmica)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['0', '0', '1', '0', '0', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Ishod meča'}
              subtitle={'Konačan ishod'}
              results={data?.results?.oddsPercentages.map(
                (result) => `${result}%`
              )}
              names={['KI 1', 'KI 2']}
              withPercent={true}
            />
            <ResultsSection
              title={'Golovi'}
              subtitle={'Granice golova'}
              results={data?.results?.goals}
              names={[
                'Očekivani minimalni br. golova na utakmici',
                'Očekivani srednji br. golova na utakmici',
                'Očekivani maksimalni br. golova na utakmici',
              ]}
              rows={2}
              breakLastItem={true}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={'Opcioni tačan rezultat na utakmici'}
              results={[
                `${data?.results?.score[0]}:${data?.results?.score[1]}`,
              ]}
              names={['Predikcija tačnog rezultata utakmice']}
            />
            <ResultsSection
              title={'Betko predlog'}
              subtitle={'Predlog igre na broj golova'}
              results={data?.results?.betko}
              names={['Predlog prve granice ( + )']}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrengths[0],
                data.results?.teamStrengths[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrengths[2],
                data.results?.teamStrengths[3],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrengths[4],
                data.results?.teamStrengths[5],
              ]}
              names={[
                'SND ( snaga napada domaćina i gosta )',
                'SOD ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={'Tim / igrač proseci odbrana i napada'}
              results={[
                data?.results?.teamStrengths[6],
                data.results?.teamStrengths[7],
              ]}
              names={[
                'SND + SOG ( dom.daje/gost prima )',
                'SOD + SNG ( dom. prima/gost daje )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AmerickiFudbal
